module.exports = __webpack_public_path__ + "img/f595cbb.png";